import { defineStore } from "pinia";
import type {
  WebModelGetAppType,
  WebModelPutAppType,
} from "~/model/api/pLCnextStoreFrontendAPI.schemas";
import {
  getAllAppTypes,
  updateAppTypeById,
} from "~/model/api/pLCnextStoreFrontendAPI";
import { withErrorMessage } from "~/helpers/withErrorMessage";
import { withLoading } from "~/helpers/withLoading";
import { withErrorHandling } from "~/helpers/withErrorHandling";
import type { TypeOption } from "~/stores/ui/specific/appsfilterstore";

interface State {
  appTypes: WebModelGetAppType[];
}

export const useAppTypesStore = defineStore("appTypes", {
  // convert to a function
  state: (): State => ({
    appTypes: [], // initial state
  }),
  getters: {
    typeOptionsForDesktopTool(state): TypeOption[] {
      const typeOptions: TypeOption[] = [];
      for (const element of state.appTypes) {
        if (element.id && element.name && !element.productcodesFromStoreRange) {
          typeOptions.push({ value: "" + element.id, text: element.name });
        }
      }
      return typeOptions;
    },
  },
  actions: {
    async loadAppTypes() {
      const { data } = await withErrorHandling(
        withErrorMessage(withLoading(getAllAppTypes())),
      );
      console.debug("loadAppTypes: ", data);
      if (data) {
        this.appTypes = data;
      }
    },
    async updateAppTypeById(
      id: number,
      webModelPutAppType: WebModelPutAppType,
    ) {
      const { data } = await withErrorMessage(
        withLoading(updateAppTypeById(id, webModelPutAppType)),
      );
      if (data) {
        await this.loadAppTypes();
      }
    },

    // easily reset state using `$reset`
    clear() {
      this.$reset();
    },
  },
});
